var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":{
      name: 'industrial_admin_tank_report',
      query: { branchId: _vm.data.branchID },
    }}},[_c('button',[_vm._v("View Details")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }